var obj = {
    // 初始化
    init: function () {
        this.aniType();           // 动画类型  
        this.bind();				    // 所有绑定事件
        this.preventInput();		// 阻止页面弹起
        this.swiper();          // 轮播图
    },
        // 动画类型
    aniType: function() {
      var location = window.location.href;
      var type = location.split('?type=')[1];
      if(type == 2) {
        $('.landing').css({'opacity': '1'});
        $('.page-1, .page-2, .year_box, .preloading').hide();
        $('.page-3').addClass('page-scale-3');
      } else {
        obj.preloading();     // 图片资源预加载
      }
    },
    // 图片资源预加载
    preloading: function () {
        var queue = new createjs.LoadQueue();
        queue.on("progress", function (e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function (e) {
            //加载完成执行操作
            $('.landing').css({'opacity': '1'});
            $('.preloading').fadeOut();
            $('.page-1').addClass('page-scale-1');
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/yssjg/images/mobile/m_logo_bg.png',
            '//static.qcplay.com/snail/yssjg/images/mobile/page_1.png',
            '//static.qcplay.com/snail/yssjg/images/mobile/page_3.png',
        ]);
    },
    // 所有绑定方法
    bind: function () {

        var Media = document.getElementById('bg-video');
          // 点击进入下一页
        $('.page').on('click', '.open-btn', function(event) {          
          Media.play();  
          $(this).fadeOut();
          var _data = $(this).attr('data');
          var _time = $(this).attr('time');
          
          obj.initPage();

          // 每一页的效果
          obj.openPage(_data, _time);
        });


        //适龄弹窗
        $(".year_box").click(function() {
          $(".year_pop").fadeIn();
        });

        $('.close-bg').click(function(event) {
            $('.pop, .popup_wrap').fadeOut();
        });

        $('.close-btn').click(function(event) {
            $(".text_pop").fadeOut();
            $(".text_wrap").fadeOut();
        });



        // 关闭视频-弹窗
        $('.video-close-bg').click(function(event) {
            $('.video-wrap').fadeOut();
            $('.s-video-btn').fadeIn();
            $('.page-5 .new-next-step-btn').fadeIn();
            Media.pause();
        });

        // 点击开启视频-弹窗
        $('.s-video-btn').click(function(event) {
            $('.video-wrap').fadeIn();
            $('.s-video-btn').fadeOut();
            Media.play();
            musicOff();
        });

        // 音频关闭
        $('.play-btn').click(function(){
            musicOff();
        });

        // 音乐按钮
        $('.music').click(function(event) {
            var _this = $(this);
            if ($('#myMusic')[0].paused) {
                $('#myMusic')[0].play();
                _this.addClass('on');
            } else {
                $('#myMusic')[0].pause();
                _this.removeClass('on')
            }
        });

        // 音频关闭
        function musicOff() {
            $('.play-btn').fadeOut();
            Media.play();
            $('#myMusic')[0].pause();
            $('.music').removeClass('on')
        }
    },

    // 初始人物消失动画
    initPage: function() {
      // 目前播放到第五页停止
      $('.circle_1, .circle_2, .circle_3, .circle_bg,').addClass("quick");  // 圆圈转速变快
      setTimeout(()=> {
        $(".entry").addClass("fade");
      }, 500)
    },

    // 翻页动画
    openPage: function(pageId, isTime) {
      setTimeout(() => {
          var pageNum = Number(pageId) + 1;
          $('.page-'+ pageId +'').addClass('page-disappear');
          setTimeout(() => {
              $('.page-'+ pageNum +'').fadeIn()
              setTimeout(() => {
                  $('.page-'+ pageNum +'').addClass('page-scale-'+ pageNum +''); 
                  setTimeout(()=> {
                    if(pageId == 1) {
                      $('.page-'+ pageNum +' .main').addClass('active'); 
                      this.nextPage()
                    }
                  }, isTime)
              }, 0);
          }, 50);
      }, isTime);
    },
    // 第二页到第三页
    nextPage: function() {
      setTimeout(()=> {
        obj.openPage("2", 1000)
      }, 500)
    },

    // 阻止默认页面弹起影响触摸位置
    preventInput: function () {
        $("input").blur(function () {
            setTimeout(function () {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 100);
        });
    },
    swiper: function() {
      var node = 0;
      var s1 = new Swiper(".main .swiper1", {
        slidesPerView: 1,
        loopAdditionalSlides: 4,
        effect: "coverflow",
        centeredSlides: !0,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: !1,
        },
        spaceBetween: 0,
        loop: !0,
        on: {
          click: function(){
            var index = this.realIndex + 1;
            $("#i"+ index +"").fadeIn();
            $(".text_pop").fadeIn();
          },
          transitionStart: function() {
            $(".bright").css("display", "none");
            $(".monster").css("display", "none");
          },
          transitionEnd: function () {
            // 切换时 node值变化
            node = this.realIndex;
            let id = node + 1;
            
            $(".b"+ id +"").fadeIn();
            $(".m"+ id +"").fadeIn();
          },
        }
      })
      var s2 = new Swiper(".main .swiper2", {
        slidesPerView: 3,
        loopAdditionalSlides: 3,
        effect: "coverflow",
        centeredSlides: !0,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: !1,
        },
        spaceBetween: 0,
        loop: !0,
        on: {
          transitionEnd: function () {
            // 切换时 node值变化
            node = this.realIndex;
          },
        }
      })
      s1.controller.control = s2
      s2.controller.control = s1
      // MySwiper = new Swiper(".main .swiper", {
      //   direction: "vertical",
      //   slidesPerView: "auto",
      //   control: [s1, s2],
      // })

      // swiper2点击切换
      
      $(".swiper2 .swiper-slide").on("click", function () {
        let index = 1 * $(this).attr("data-index");
          if(node == index) {
            return 
          }
          if (4 == node && index == 0) {
            void (node = index);
            return s2.slideNext()
          }
          if (0 == node && index == 4) {
            void (node = index);
            return s2.slidePrev()
          }
          
          node > index
          ? s2.slidePrev()
          : s2.slideNext(), node = index;
      })
    }
}